import React, { useEffect } from 'react'
import { addDays } from 'date-fns'
import { useFormik } from 'formik'
import { Grid, GridItem, Text, Checkbox } from '@chakra-ui/react'
import { InputComtrol, CustomDatePicker, Select } from '../../UI'
import {
  GradesCarabineros,
  FormatRut,
  FormatCode,
  ZonesTwoList
} from '../../../Utils'
import { steepOneSchema } from './Schemas'
import Applicants from './Applicants'

const StepOne = ({ stepOneForm, setStepOneForm, refStepOne, next }) => {
  const initialValues = {
    alternativePhone: '',
    receptionDate: '',
    zone: stepOneForm.partnerZone || ZonesTwoList.getRegions().at(0),
    prefecture:
      stepOneForm.partnerPrefecture ||
      ZonesTwoList.getCommunes(ZonesTwoList.getRegions().at(0)).at(0),
    unit: stepOneForm.partnerEndowment || '',
    /* partner field */
    partnerId: '',
    partnerRut: '',
    partnerPhone: '',
    partnerGrade: GradesCarabineros.at(0),
    partnerCode: '',
    partnerZone: stepOneForm.partnerZone || ZonesTwoList.getRegions().at(0),
    partnerPrefecture:
      stepOneForm.partnerPrefecture ||
      ZonesTwoList.getCommunes(ZonesTwoList.getRegions().at(0)).at(0),
    partnerEndowment: stepOneForm.partnerEndowment || '',
    /* pacient field */
    isPartnerApplicant: false,
    applicants: stepOneForm.applicants || []
    /* end pacient field */
  }

  const formik = useFormik({
    initialValues,
    validationSchema: steepOneSchema,
    validateOnMount: false,
    validateOnChange: false,
    onSubmit: (values) => {
      if (!values.isPartnerApplicant) {
        if (values.applicants.length > 0) {
          setStepOneForm({
            ...values
          })
          next()
        }
      } else {
        setStepOneForm({
          ...values
        })
        next()
      }
    }
  })

  const handleChangeReceptionDate = (value) => {
    formik.setFieldValue('receptionDate', value)
  }

  const hadleChangeZone = (value) => {
    formik.setFieldValue('zone', value)
    formik.setFieldValue('prefecture', ZonesTwoList.getCommunes(value).at(0))
  }

  const handleChangePrefecture = (value) => {
    formik.setFieldValue('prefecture', value)
  }

  const hadleChangePartnerZone = (value) => {
    formik.setFieldValue('partnerZone', value)
    formik.setFieldValue(
      'partnerPrefecture',
      ZonesTwoList.getCommunes(value).at(0)
    )
  }

  const handleChangePartnerPrefecture = (value) => {
    formik.setFieldValue('partnerPrefecture', value)
  }

  const handleChangePartnerGrade = (value) => {
    formik.setFieldValue('partnerGrade', value)
  }

  const handleChangeRut = () => {
    if (formik.values.partnerRut) {
      const formatedRut = FormatRut(formik.values.partnerRut)
      formik.setFieldValue('partnerRut', formatedRut)
    }
  }

  const handleChangeIsPartnerZone = (e) => {
    const isChecked = e.target.checked

    if (isChecked) {
      formik.setValues({
        ...formik.values,
        isPartnerZone: isChecked,
        zone: formik.values.partnerZone,
        prefecture: formik.values.partnerPrefecture,
        unit: formik.values.partnerEndowment
      })
    } else {
      formik.setValues({
        ...formik.values,
        isPartnerZone: isChecked
      })
    }
  }

  const formatCode = () => {
    if (formik.values.partnerCode) {
      const formatedCode = FormatCode(formik.values.partnerCode)
      formik.setFieldValue('partnerCode', formatedCode)
    }
  }

  useEffect(() => {
    refStepOne.current = formik.handleSubmit
  }, [])

  useEffect(() => {
    formik.setValues({
      receptionDate: stepOneForm.receptionDate || '',
      alternativePhone: stepOneForm.alternativePhone || '',
      isPartnerZone: stepOneForm.isPartnerZone || false,
      zone:
        stepOneForm.zone ||
        stepOneForm.partnerZone ||
        ZonesTwoList.getRegions().at(0),
      prefecture:
        stepOneForm.prefecture ||
        stepOneForm.partnerPrefecture ||
        ZonesTwoList.getCommunes(ZonesTwoList.getRegions().at(0)).at(0),
      unit: stepOneForm.unit || stepOneForm.partnerEndowment,
      /* partner field */
      partnerId: stepOneForm.partnerId || '',
      partnerRut: stepOneForm.partnerRut || '',
      partnerPhone: stepOneForm.partnerPhone || '',
      partnerGrade: stepOneForm.partnerGrade || GradesCarabineros.at(0),
      partnerCode: stepOneForm.partnerCode || '',
      partnerZone: stepOneForm.partnerZone || ZonesTwoList.getRegions().at(0),
      partnerPrefecture:
        stepOneForm.partnerPrefecture ||
        ZonesTwoList.getCommunes(ZonesTwoList.getRegions().at(0)).at(0),
      partnerEndowment: stepOneForm.partnerEndowment || '',
      isPartnerApplicant: stepOneForm.isPartnerApplicant || false,
      applicants: stepOneForm.applicants || []
    })
  }, [stepOneForm])

  return (
    <>
      <Grid
        templateColumns={{
          lg: 'repeat(3, 1fr)',
          md: 'repeat(1, 1fr)',
          sm: 'repeat(1, 1fr)'
        }}
        gap={2}
      >
        <GridItem>
          <Text fontWeight={700} color={'green.500'} fontSize={'xl'}>
            Información de solicitud
          </Text>
          <InputComtrol
            id={'receptionDate'}
            label={'Fecha de recepción de solicitud'}
          >
            <CustomDatePicker
              placeholder={'DD/MM/AAAA'}
              currentDate={formik.values.receptionDate}
              onChange={(date) => handleChangeReceptionDate(date)}
              error={Boolean(formik.errors.receptionDate)}
              errorText={formik.errors.receptionDate}
              maxDate={addDays(new Date(), 0)}
            />
          </InputComtrol>
        </GridItem>
      </Grid>
      {/* partner data */}
      <Grid
        templateColumns={{
          lg: 'repeat(2, 1fr)',
          md: 'repeat(1, 1fr)',
          sm: 'repeat(1, 1fr)'
        }}
        gap={2}
      >
        <GridItem>
          <Text fontWeight={700} color={'green.500'} fontSize={'xl'}>
            Información del Socio (Opcionales)
          </Text>
          <InputComtrol
            id={'partnerRut'}
            label={'Rut Socio'}
            isRequired={false}
            value={formik.values.partnerRut}
            onChange={formik.handleChange}
            onBlur={handleChangeRut}
            error={Boolean(formik.errors.partnerRut)}
            errorText={formik.errors.partnerRut}
          />
          <InputComtrol
            id={'partnerPhone'}
            label={'Teléfono Socio'}
            isRequired={false}
            type={'number'}
            addictionType={'phone'}
            value={formik.values.partnerPhone}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.partnerPhone)}
            errorText={formik.errors.partnerPhone}
          />

          <InputComtrol
            id={'partnerGrade'}
            label={'Grado Socio'}
            isRequired={false}
          >
            <Select
              bg={'white'}
              list={GradesCarabineros}
              value={formik.values.partnerGrade}
              onChange={handleChangePartnerGrade}
            />
          </InputComtrol>
          <InputComtrol
            id={'partnerPrefecture'}
            label={'Alta repartición / Repartición Socio'}
            isRequired={false}
            error={Boolean(formik.errors.partnerPrefecture)}
            errorText={formik.errors.partnerPrefecture}
          >
            <Select
              bg={'white'}
              list={ZonesTwoList.getCommunes(formik.values.partnerZone)}
              value={formik.values.partnerPrefecture}
              onChange={handleChangePartnerPrefecture}
            />
          </InputComtrol>
        </GridItem>
        <GridItem>
          <Text fontSize={'xl'} opacity={0}>
            -----
          </Text>

          <InputComtrol
            id={'partnerCode'}
            label={'Código Socio. ej: 001001-D'}
            isRequired={false}
            value={formik.values.partnerCode}
            onChange={formik.handleChange}
            onBlur={formatCode}
            error={Boolean(formik.errors.partnerCode)}
            errorText={formik.errors.partnerCode}
          />
          <InputComtrol
            id={'alternativePhone'}
            isRequired={false}
            label={'Teléfono alternativo'}
            type={'number'}
            addictionType={'phone'}
            value={formik.values.alternativePhone}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.alternativePhone)}
            errorText={formik.errors.alternativePhone}
          />
          <InputComtrol
            id={'partnerZone'}
            label={'Zona Socio'}
            isRequired={false}
          >
            <Select
              bg={'white'}
              list={ZonesTwoList.getRegions()}
              value={formik.values.partnerZone}
              onChange={hadleChangePartnerZone}
              error={Boolean(formik.errors.partnerZone)}
              errorText={formik.errors.partnerZone}
            />
          </InputComtrol>
          <InputComtrol
            id={'partnerEndowment'}
            label={'Unidad Socio'}
            isRequired={false}
            value={formik.values.partnerEndowment}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.partnerEndowment)}
            errorText={formik.errors.partnerEndowment}
          />
        </GridItem>
      </Grid>
      {/* end partner data */}
      <Grid
        templateColumns={{
          lg: 'repeat(2, 1fr)',
          md: 'repeat(1, 1fr)',
          sm: 'repeat(1, 1fr)'
        }}
        gap={2}
      >
        <GridItem>
          <Text fontWeight={700} color={'green.500'} fontSize={'xl'}>
            Zona de postulación
          </Text>
        </GridItem>
        <GridItem>
          <Checkbox
            css={{ borderColor: 'green' }}
            id={'isPartnerZone'}
            size="md"
            colorScheme="green"
            isChecked={formik.values.isPartnerZone}
            value={formik.values.isPartnerZone}
            onChange={handleChangeIsPartnerZone}
            py={4}
            fontWeight={700}
          >
            ¿Es la zona actual del socio?
          </Checkbox>
        </GridItem>
        <GridItem>
          <InputComtrol id={'zone'} label={'Zona'}>
            <Select
              bg={'white'}
              list={ZonesTwoList.getRegions()}
              value={formik.values.zone}
              onChange={hadleChangeZone}
              error={Boolean(formik.errors.zone)}
              errorText={formik.errors.zone}
            />
          </InputComtrol>
        </GridItem>
        <GridItem>
          {/* <Text fontSize={'xl'} opacity={0}>
            -----
          </Text> */}
          <InputComtrol
            id={'prefecture'}
            label={'Alta repartición / Repartición'}
            error={Boolean(formik.errors.prefecture)}
            errorText={formik.errors.prefecture}
          >
            <Select
              bg={'white'}
              list={ZonesTwoList.getCommunes(formik.values.zone)}
              value={formik.values.prefecture}
              onChange={handleChangePrefecture}
            />
          </InputComtrol>
        </GridItem>
      </Grid>
      <Grid
        templateColumns={{
          lg: 'repeat(1, 1fr)',
          md: 'repeat(1, 1fr)',
          sm: 'repeat(1, 1fr)'
        }}
        gap={2}
      >
        <GridItem>
          <InputComtrol
            id={'unit'}
            label={'Unidad'}
            value={formik.values.unit}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.unit)}
            errorText={formik.errors.unit}
          />
        </GridItem>
      </Grid>
      <Grid templateColumns={'repeat(1, 1fr)'} gap={2}>
        <GridItem ml={'auto'} mr={'auto'}>
          <Checkbox
            css={{ borderColor: 'green' }}
            id={'isPartnerApplicant'}
            size="md"
            colorScheme="green"
            isChecked={formik.values.isPartnerApplicant}
            value={formik.values.isPartnerApplicant}
            onChange={formik.handleChange}
            py={4}
            fontWeight={700}
          >
            ¿El solicitante es el actual socio?
          </Checkbox>
        </GridItem>
      </Grid>
      <Applicants formik={formik} />
    </>
  )
}

export default StepOne
